import { render, staticRenderFns } from "./CP.vue?vue&type=template&id=499b0aec&scoped=true"
import script from "./CP.vue?vue&type=script&lang=js"
export * from "./CP.vue?vue&type=script&lang=js"
import style0 from "./CP.vue?vue&type=style&index=0&id=499b0aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b0aec",
  null
  
)

export default component.exports